import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import InputBox from "./InputBox";
import { Box, Stack } from "@mui/system";
import { Alert, Card, Chip, LinearProgress, Typography } from "@mui/material";
import cogoToast from "cogo-toast";
import { View500 } from "src/sections/error";
import CaseAtMessage from "./CaseAtMessage";
import _ from "lodash";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { niceDateTime } from "../utils/fn";

class Case extends React.Component {
  state = {
    isLoading: true,
    isError: false,
    messages: [],
    chosenMessageNanoId: null,
  };
  componentDidMount() {
    this.getCaseByID();
  }
  getCaseByID = async () => {
    const { id } = this.props;
    try {
      let res = await this.props.apiCallPost("/harley/getCaseById", {
        caseId: id,
      });
      this.setState({
        isLoading: false,
        ...res,
      });
    } catch (err) {
      this.setState({
        isLoading: false,
        isError: true,
      });
      cogoToast.error("Error fetching case");
    }
  };
  renderInputBox = () => {
    return (
      <Stack spacing={2}>
        <Box>
          <Chip label="Speak or write your encounter notes." color="info" />
        </Box>
        <InputBox
          caseId={this.props.id}
          isCaseNote={true}
          onAddMessage={(res, nn) =>
            this.setState({
              ...res,
              chosenMessageNanoId: nn,
            })
          }
        />
      </Stack>
    );
  };
  renderMessagesBar = () => {
    let messages = this.state.messages;
    if (!messages || !messages.length) {
      return <Alert severity="warning">No dictation notes yet.</Alert>;
    }
    return (
      <Stack spacing={1}>
        {messages.map((each) => {
          let cardSx = {
            p: 2,
            m: 2,
            bgcolor: "background.paper",
            fontSize: "small",
          };
          if (each.nanoid === this.state.chosenMessageNanoId) {
            cardSx["bgcolor"] = "success.light";
          }
          return (
            <Card
              sx={cardSx}
              onClick={() => {
                if (this.state.chosenMessageNanoId === each.nanoid) {
                  this.setState({
                    chosenMessageNanoId: null,
                  });
                } else {
                  this.setState({
                    chosenMessageNanoId: each.nanoid,
                  });
                }
              }}
            >
              <Stack spacing={0}>
                <Typography variant="overline">
                  {each.audioTranscript}
                </Typography>
                <Typography variant="caption">
                  {niceDateTime(each.ts)}
                </Typography>
              </Stack>
            </Card>
          );
        })}
      </Stack>
    );
  };
  renderCaseAtMessage = () => {
    if (!this.state.chosenMessageNanoId) {
      return null;
    }
    let idx = _.findIndex(
      this.state.messages,
      (x) => x.nanoid === this.state.chosenMessageNanoId
    );
    let obj = this.state.messages[idx];

    return (
      <CaseAtMessage
        data={obj}
        caseId={this.props.id}
        key={this.state.chosenMessageNanoId}
      />
    );
  };
  render() {
    if (this.state.isLoading) {
      return <LinearProgress />;
    }
    if (this.state.isError) {
      return <View500 />;
    }
    return (
      <div>
        <Grid container spacing={3}>
          {" "}
          <Grid xs={12} md={5}>
            <Stack spacing={2}>
              {this.renderInputBox()}
              {this.renderMessagesBar()}
            </Stack>
          </Grid>
          <Grid xs={12} md={7}>
            {this.renderCaseAtMessage()}
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default WithAPICall(Case);
